import { render } from "./PayerComments.vue?vue&type=template&id=2fbb2690&ts=true"
import script from "./PayerComments.ts?vue&type=script&lang=ts&external"
export * from "./PayerComments.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__